import { Moment } from 'moment-mini'
import { Resource } from 'src/app/shared/interfaces'
import { Product } from '../../product/product'
import { Sale } from '../sale'
import { Booking } from '../../booking/booking'
import { Subscription } from '../../subscription/subscription'
import { Course } from '../../course/course'
import { Answer } from '../../survey/answer/answer'

export class SaleItem extends Resource {
  id?: number
  saleId: number
  saleLine?: number
  productId: number
  bookingId: number
  courseId?: number
  subscriptionId?: number
  subscriberId?: number
  quantity: number
  totalPrice?: string
  totalVat?: string
  vatPercentage?: string
  siteId?: number
  description?: string
  params?: PurchaseParams
  note?: string
  memo?: string
  giftCardUseId: number
  customerCategory?: number
  childProductId: number
  rentalId?: number
  claimCode?: string
  serieProposalItemId?: number
  date?: Moment
  claimableEndDate: Moment
  claimableStartDate: Moment
  // relations
  sale?: Sale
  course?: Course
  subscription?: Subscription
  product?: Product
  tags?: number[]
  booking?: Booking
}

export class InvitedPersonDto {
  email?: string
  firstName?: string
  lastName?: string
  mobile?: string
  category?: number
}

export class PurchaseParams {
  bookableProductId?: number
  bookableLinkedProductId?: number
  bookingId?: number
  startDate?: Moment
  defaultStartDate?: Moment
  paidTillDate?: Moment
  endDate?: Moment
  invitedGuests?: InvitedPersonDto[]
  invitedOthers?: InvitedPersonDto[]
  invitedMemberEmails?: string[]
  familyMembersInvited?: number[]
  primaryPurchaseMessage?: string
  secondaryPurchaseMessage?: string
  giftCardReferenceCode?: string
  rentStartDate?: Moment
  rentEndDate?: Moment
  totalPricePerPeriod?: boolean
  totalParticipantInvitations?: number
  bookerAssisting?: boolean
  surveyAnswers?: Partial<Answer>[]
}
